/**
 * Route for `cap-periods-hourly-daily-monthly-lifetime`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CapPeriodsHourlyDailyMonthlyLifetimePage } from "../features/cap-periods-hourly-daily-monthly-lifetime/CapPeriodsHourlyDailyMonthlyLifetimePage";

export const capPeriodsHourlyDailyMonthlyLifetimeRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/cap-periods-hourly-daily-monthly-lifetime",
	component: CapPeriodsHourlyDailyMonthlyLifetimePage,
});

export default capPeriodsHourlyDailyMonthlyLifetimeRoute;
